

































import { Vue, Component } from "../vue-ext";
import { Material, HousingCompany, FileType } from "../models";

@Component
export default class MaterialView extends Vue {
    private material: Material | null = null;
    private housingCompany: HousingCompany | null = null;
    FileType = FileType;

    private async created() {
        this.root.setTitle(this.$t("menu.materials") as string);
        this.root.setIconClass("icon-materials");
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;

        const id = parseInt(this.$route.params.id, 10);

        if (id) {
            this.material = this.root.getMaterial(id) as Material; 
        }
    }
}
